/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const DropdownArrow = (props: { className?: string }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="9.537"
    height="6.1"
    viewBox="0 0 9.537 6.1"
  >
    <path
      id="Tracé_6245"
      data-name="Tracé 6245"
      d="M8.807,12.271l3.44,3.44a1.323,1.323,0,0,0,1.873,0l3.44-3.44A1.332,1.332,0,0,0,16.617,10H9.737A1.328,1.328,0,0,0,8.807,12.271Z"
      transform="translate(-8.414 -10)"
      fill="#0c1f40"
    />
  </svg>
);

export { DropdownArrow };
